import { createStandardActions, GetActions, placeholder, readonly, standardItemsReducer } from "../utils";
import {createStandardSelectors, getEntities, selector} from "../selectors";
import { combineReducers } from "redux";
import {createAction, createReducer} from "typesafe-actions";
import {Dictionary} from "../../types";
import {User, UserActions, UserItems} from "./user";

export interface AuditLog {
  id: number;
  tableName: string;
  entityId: string;
  propertyName?: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  action: string;
  userId?: string | null;
  changedAt: string;
}

export interface AuditLogState {
  entityLogs: AuditLogItems;
  items: AuditLogItems;
}

export interface AuditLogItems {
  [key: number]: AuditLog;
}

const partialDataActions = {
  setIncludedData: createAction('AUDITLOG/SET_INCLUDED_DATA')<Dictionary<AuditLog>>()
};

export type AuditLogActions = GetActions<typeof actions>;

const actions = createStandardActions(placeholder<AuditLog>(), 'AUDITLOG/SET', 'AUDITLOG/SAVE');
const selectors = createStandardSelectors(placeholder<AuditLog>(), s => (getEntities(s) as any).auditlogs);
export const auditlogs = combineReducers<AuditLogState>({
  items: standardItemsReducer<AuditLog, AuditLogActions>(actions),
  // Holds included audit log data set via setIncludedData; replace with provided dictionary
  entityLogs: createReducer<AuditLogItems, GetActions<typeof partialDataActions>>({})
    .handleAction(partialDataActions.setIncludedData, (_state, action) => ({ ...action.payload }))
});
export const auditLogStore = readonly({
  selectors: {
    ...selectors,
    getEntityAuditLogs: selector(s => selectors.getState(s).entityLogs),
  },
  actions: {
    ...actions,
    ...partialDataActions,
  }
});
